import React, { Component, useState, useEffect } from "react";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { getAllRaces } from "../../service/backend-api-service";
import horseImage from '../../assets/images/horse_icon.png'
import harnessImage from '../../assets/images/harness_icon.png'

const RaceSlidingPane = props => {
    const [races, setRaces] = useState([])

    const handleSelect = (e, item) => {
        let allButtons = document.querySelectorAll("#raceButton")
        allButtons.forEach(aButton => {
            aButton.style.backgroundColor = ''
        });
        e.target.style.backgroundColor = "black"
        props.raceSelectHandler(item);
    }

    const formatDate = (dateInYYYYMMDD) => {
        const year = dateInYYYYMMDD.substring(0, 4);
        const month = dateInYYYYMMDD.substring(4, 6);
        const day = dateInYYYYMMDD.substring(6, 8);
        return day + "/" + month + "/" + year;
    }

    useEffect(() => {
        const fetchData = async () => {
            let date = props.selectionDate
            let apiData = await getAllRaces(date)
            setRaces(apiData)
            let allButtons = document.querySelectorAll("#raceButton")
            allButtons.forEach(aButton => {
                aButton.style.backgroundColor = ''
            });
        }
        fetchData();
    }, [props.selectionDate])

    const filterUK = (item) => {
        return item.trackName.indexOf("UK") === -1;
    }

    const itemList = races.filter(filterUK).map((item, index) => {
        var raceType = null
        if (item.raceType === 'HORSE') {
            raceType = <img src={horseImage} style={{ width: "25px", height: "20px" }} />
        } else if (item.raceType === 'HARNESS') {
            raceType = <img src={harnessImage} style={{ width: "25px", height: "20px" }} />
        }


        return <>
            <Button id="raceButton" style={{width:"210px",flexDirection:"column-reverse", fontSize: "12px", fontWeight: "bold", color: "white" }} onClick={(e) => handleSelect(e, item)} variant="secondary" size="sm">
                {raceType} R{item.raceId} {item.trackName.substr(item.trackName.indexOf(" ") + 1)}  {item.raceTime}
            </Button></>
    });

    return (
        <div >

            {itemList}
            <Button id="raceButton" style={{ width: "200px",fontSize: "12px", fontWeight: "bold", color: "white" }} onClick={(e) => handleSelect(e, { date: props.selectionDate, type: 'ALL' })} variant="secondary" size="sm">
                Meetings for {formatDate(props.selectionDate)}
            </Button>
        </div>
    );
}

export default RaceSlidingPane;